export default function device() {
  return {
    isMobile: window.innerWidth > 768 ? false : true,
    width: window.innerWidth,
    height: window.innerHeight,
  };
}
